import React from 'react';
import classnames from 'classnames';
import ArrowRightIcon from '@wix/da-ds/pkg/Icons/16x16/ArrowRight';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import { useMMDispatchActions } from '../../_hocs/withOwnReduxStore';
import { initGallectionStream, initGallectionDeviationStream, initTierStream } from '../../actions';
import { useTranslation } from 'react-i18next';
import { useCurrentGallection } from '../../_hocs/withCurrentGallection';
import { useCurrentSubfolder } from '../../_hocs/withCurrentSubfolder';
import { useSearch } from '../../_hocs/withSearch';
import { useCurrentMediaSource } from '../../_hocs/withCurrentMediaSource';
import { MediaSourceType } from '../../types';
import { useCurrentTier } from '../../_hocs/withCurrentTier';
import s from './Breadcrumbs.scss';
export const Breadcrumbs = ()=>{
    const { t  } = useTranslation();
    const { currentMediaSource  } = useCurrentMediaSource();
    const { currentGallection , unsetCurrentFolderId  } = useCurrentGallection();
    const { currentSubfolder , unsetCurrentSubfolderId  } = useCurrentSubfolder();
    const { currentTier , unsetCurrentTierId  } = useCurrentTier();
    const { searchQuery , unsetSearchInput , unsetSearchQuery  } = useSearch();
    const actions = useMMDispatchActions({
        initGallectionStream,
        initGallectionDeviationStream,
        initTierStream
    });
    if (currentMediaSource === MediaSourceType.CUSTOM_SET) {
        return null;
    }
    const crumbs = [];
    if (currentMediaSource === MediaSourceType.BROWSE) {
        crumbs.push({
            node: t(searchQuery ? 'mediapopup.search.searchResults' : 'mediapopup.browse')
        });
    } else {
        let allKey;
        switch(currentMediaSource){
            case MediaSourceType.GALLERY:
                allKey = 'mediapopup.myGalleries';
                break;
            case MediaSourceType.COLLECTION:
                allKey = 'mediapopup.myCollections';
                break;
            case MediaSourceType.PRIVATE_COLLECTION:
                allKey = 'mediapopup.myPrivateCollections';
                break;
            case MediaSourceType.STATUS:
                allKey = 'mediapopup.myStatuses';
                break;
            case MediaSourceType.JOURNAL:
                allKey = 'mediapopup.myJournals';
                break;
            case MediaSourceType.POLL:
                allKey = 'mediapopup.myPolls';
                break;
            case MediaSourceType.POSTS:
                allKey = 'mediapopup.myPosts';
                break;
            case MediaSourceType.TIER:
                allKey = 'mediapopup.tiers';
                break;
            case MediaSourceType.COMMISSIONS:
                allKey = 'mediapopup.commissions';
                break;
            case MediaSourceType.TIER_DEVIATIONS:
            case MediaSourceType.TIER_POSTS:
                allKey = 'mediapopup.allTiers';
                break;
            default:
                allKey = 'mediapopup.allFolders';
                break;
        }
        crumbs.push({
            node: t(allKey),
            onClick: ()=>{
                unsetCurrentFolderId();
                unsetCurrentSubfolderId();
                unsetSearchInput();
                unsetSearchQuery();
                unsetCurrentTierId();
                if (currentMediaSource && [
                    MediaSourceType.GALLERY,
                    MediaSourceType.PRIVATE_COLLECTION,
                    MediaSourceType.COLLECTION,
                    MediaSourceType.STASH
                ].includes(currentMediaSource)) {
                    actions.initGallectionStream();
                } else if (currentMediaSource && [
                    MediaSourceType.TIER_DEVIATIONS,
                    MediaSourceType.TIER_POSTS
                ].includes(currentMediaSource)) {
                    actions.initTierStream();
                }
            }
        });
        if (currentGallection) {
            crumbs.push({
                node: currentGallection.name,
                onClick: ()=>{
                    unsetCurrentSubfolderId();
                    actions.initGallectionDeviationStream();
                }
            });
        }
        if (searchQuery) {
            crumbs.push({
                node: searchQuery
            });
        }
        if (currentSubfolder) {
            crumbs.push({
                node: currentSubfolder.name
            });
        }
        if (currentTier) {
            crumbs.push({
                node: currentTier.title
            });
        }
    }
    return /*#__PURE__*/ React.createElement("div", {
        className: s['root']
    }, crumbs.map((crumb, index)=>/*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("span", {
            key: index,
            className: classnames(s['crumb'], index === crumbs.length - 1 && s['active']),
            onClick: crumb.onClick
        }, crumb.node), crumbs[index + 1] && /*#__PURE__*/ React.createElement(ArrowRightIcon, {
            size: IconSize.TINY,
            className: s['divider'],
            disableDefaultColors: true
        }))));
};
Breadcrumbs.displayName = 'Breadcrumbs';
export default Breadcrumbs;
